import { useSearchFilterStore } from '@/entities/map'
import { Icon, TextButton } from '@/shared/ui'

export const ResetButton = () => {
  const actions = useSearchFilterStore(state => state.actions)

  const handleReset = () => {
    actions.resetFilters()
  }

  return (
    <div className="fixed right-0 flex h-[48px] items-center bg-white pr-6 xl:sticky">
      <div className="absolute right-full h-full w-8 bg-gradient-to-r from-transparent to-white" />
      <TextButton size="large" color="black" onClick={handleReset}>
        <Icon name="reset" />
        초기화
      </TextButton>
    </div>
  )
}
